export const initialFilterValues = [null, null]
